/***
*
*   AUTHENTICATION
*   Auth provider to manage auth functions throughout
*   the application. <PrivateRoute> component to
*   protect internal application routes from unauthenticated
*   access.
*
**********/

import React, { useState } from 'react';
import axios from 'axios';
import Settings from 'settings.json';
import { Navigate } from 'react-router-dom';
import store from '../store/store';
import { fetchMyPermissions } from '../store/slices/rbacSlice';

// auth context
export const AuthContext = React.createContext();

const accountTypes = require('./accountTypes.json');

export function AuthProvider(props) {

  const cache = JSON.parse(localStorage.getItem('user'));
  const [user, setUser] = useState(cache);

  function signin(res, impersonate) {

    if (res.data?.data) {
      localStorage.setItem('user', JSON.stringify(res.data.data));
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + res.data.data.token;

      if (res.data.helperData.accountType !== 'master')
        return window.location = '/signin';

      // Fetch RBAC permissions after login, then redirect
      store.dispatch(fetchMyPermissions()).finally(() => {
        window.location = impersonate ?
          `${Settings[process.env.REACT_APP_YOSUITE_ENV_MODE].remote_client}/dashboard` : '/dashboard';
      });

    }

  }

  async function signout() {

    axios({ method: 'delete', url: `${Settings[process.env.REACT_APP_YOSUITE_ENV_MODE].server_url}/api/auth` });
    localStorage.clear();
    window.location = '/signin'

  }

  function update(data) {

    if (localStorage.getItem('user')) {

      let user = JSON.parse(localStorage.getItem('user'));
      for (let key in data) {

        if (Array.isArray(data[key])) {

          user[key] = data[key]

        }
        else if (typeof data[key] === 'object') {
          for (let innerKey in data[key]) {

            user[key][innerKey] = data[key][innerKey]

          }
        }
        else {

          user[key] = data[key];

        }
      }

      localStorage.setItem('user', JSON.stringify(user));
      setUser(user);

    }
  }

  return (
    <AuthContext.Provider value={{

      user: user,
      signin: signin,
      signout: signout,
      update: update,
      remote_server: Settings[process.env.REACT_APP_YOSUITE_ENV_MODE].remote_server,
      server_url: Settings[process.env.REACT_APP_YOSUITE_ENV_MODE].server_url,
      accountType: accountTypes[user?.accountType]

    }}

      {...props} />
  );
}

// Map route paths to menu keys for permission checking
const ROUTE_MENU_MAP = {
  '/dashboard': 'dashboard',
  '/bundle-packaging': 'bundle_packaging',
  '/alerts': 'alerts',
  '/feedback': 'feedback',
  '/support': 'support',
  '/signup-promotional-data': 'signup_data',
  '/workspaces': 'workspaces',
  '/accounts': 'accounts',
  '/users': 'users',
  '/logs': 'logs',
  '/events': 'events',
  '/settings': 'settings'
};

// custom route object checks for an auth token before
// rendering the route – redirects if token is not present
export function PrivateRoute(props) {

  const user = JSON.parse(localStorage.getItem('user'));

  // Not authenticated at all
  if (!user?.token) {
    return <Navigate to='/signin' />;
  }

  console.log('user', user)
  // Wrong account type - FIX: use accountType (camelCase) instead of account_type
  // if (props.accountType && user?.accountType !== props.accountType) {
  //   return <Navigate to='/signin' />;
  // }

  // Check RBAC permission for the current route
  const rbacState = store.getState().rbac;
  const permissions = rbacState?.myPermissions?.permissions;
  const rbacLoading = rbacState?.loading;

  // If RBAC is still loading, allow through — AppLayout will show fallback nav
  // This prevents redirect loop while permissions are being fetched
  if (rbacLoading) {
    return props.children;
  }

  // If permissions are loaded, enforce route-level access
  if (permissions) {
    const currentPath = window.location.pathname;
    let menuKey = null;
    for (const [path, key] of Object.entries(ROUTE_MENU_MAP)) {
      if (currentPath === path || currentPath.startsWith(path + '/')) {
        menuKey = key;
        break;
      }
    }

    if (menuKey && permissions[menuKey] && !permissions[menuKey].view) {
      return <Navigate to='/dashboard' />;
    }
  }

  return props.children;
}